import { Command } from 'cmdk';
import { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useConnections } from './connections-v2/hooks/useConnections';
import { Badge } from '@chakra-ui/react';
import { ConnectionType } from './connection-detail-v2/components/ConnectionType';
import { ConnectionCategory } from '@finch-api/common/dist/external/dashboard/connection-status';
import { useOrganizationApplications } from './shared/OrganizationApplicationsContext';
import { ApplicationStatusBadge } from './credentials/components/ApplicationStatusBadge';

export const CommandMenu = () => {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const { applicationId } = useParams<{ applicationId: string }>();

  // Toggle the menu when ⌘K is pressed
  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((open) => !open);
      }
    };

    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, []);

  const { connections } = useConnections();
  const applications = useOrganizationApplications();

  return (
    <Command.Dialog
      open={open}
      onOpenChange={setOpen}
      label="Global Command Menu"
    >
      <Command.Input
        placeholder="Search for something"
        style={{
          borderBottom: '1px solid #c2c2c2',
        }}
      />
      <Command.List
        style={{
          padding: '10px 0',
        }}
      >
        <Command.Empty>No results found.</Command.Empty>
        <Command.Group heading="Pages">
          <Command.Item
            {...{
              onSelect: () => {
                history.push(`/app/applications/${applicationId}/credentials`);
              },
              style: {
                borderBottom: '1px solid rgb(225, 225, 225)',
              },
            }}
          >
            Credentials
          </Command.Item>
          <Command.Item
            {...{
              onSelect: () => {
                history.push(`/app/applications/${applicationId}/connections`);
              },
              style: {
                borderBottom: '1px solid rgb(225, 225, 225)',
              },
            }}
          >
            Connections
          </Command.Item>
          <Command.Item
            {...{
              onSelect: () => {
                history.push(`/app/applications/${applicationId}/integrations`);
              },
              style: {
                borderBottom: '1px solid rgb(225, 225, 225)',
              },
            }}
          >
            Integrations
          </Command.Item>
          <Command.Item
            {...{
              onSelect: () => {
                history.push(`/app/applications/${applicationId}/webhooks`);
              },
              style: {
                borderBottom: '1px solid rgb(225, 225, 225)',
              },
            }}
          >
            Webhooks
          </Command.Item>
          <Command.Item
            {...{
              onSelect: () => {
                history.push(`/app/applications/${applicationId}/activity`);
              },
              style: {
                borderBottom: '1px solid rgb(225, 225, 225)',
              },
            }}
          >
            Activity
          </Command.Item>
        </Command.Group>
        <Command.Group heading="Applications">
          {applications.map((application) => (
            <Command.Item
              key={application.id}
              onSelect={() => {
                history.push(`/app/applications/${application.id}`);
              }}
              style={{
                borderBottom: '1px solid rgb(225, 225, 225)',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '5px',
                    alignItems: 'center',
                  }}
                >
                  <ApplicationStatusBadge
                    applicationType={application.status}
                    style={{
                      height: 'fit-content',
                      padding: '0px 5px',
                    }}
                  />
                  {application.name}
                </div>
                <Badge>{application.id}</Badge>
              </div>
            </Command.Item>
          ))}
        </Command.Group>
        <Command.Group heading="Connections">
          {connections.map((connection) => (
            <Command.Item
              key={connection.id}
              onSelect={() => {
                history.push(
                  `/app/applications/${applicationId}/connections/${connection.id}`,
                );
              }}
              style={{
                borderBottom: '1px solid rgb(225, 225, 225)',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '5px',
                    alignItems: 'center',
                  }}
                >
                  <ConnectionType
                    key={connection.id}
                    kind={
                      connection.implementationKind === 'assisted'
                        ? ConnectionCategory.Assisted
                        : ConnectionCategory.Automated
                    }
                    disconnected={false}
                    noCaption
                  />
                  {connection.companyName}
                </div>
                <Badge>{connection.id}</Badge>
              </div>
            </Command.Item>
          ))}
        </Command.Group>
      </Command.List>
    </Command.Dialog>
  );
};
